import { Box, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function FileIconForTable({ row, theme }) {
    return (
        <Box
            sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Iconify
                icon="fluent:document-32-filled"
                color={theme.palette.primary.main}
                sx={{ height: 36, width: 36 }}
            />
            <Typography
                sx={{
                    position: "absolute",
                    bottom: 1.5,
                    right: 3.5,
                    px: 0.5,
                    fontSize: "10px",
                    fontWeight: "bold",
                    color: "common.white",
                    textAlign: "left",
                }}
            >
                {row.fileType}
            </Typography>
        </Box>
    )
}
